import createAction from "@web-monorepo/infra/createAction";
import createActionCreator from "@web-monorepo/infra/createActionCreator";
import createReducer from "@web-monorepo/infra/createReducer";
import { IdeasState } from "src/pods/ideas";

const SELECT_IDEAS_BOARD = createAction("ideas/selectBoard");
const UNSELECT_IDEAS_BOARD = createAction("ideas/unselectBoard");

export const selectBoard = createActionCreator(SELECT_IDEAS_BOARD, (slug: string) => ({
  slug,
}));
export const unselectBoard = createActionCreator(SELECT_IDEAS_BOARD);

export const selectBoardHandler = createReducer(
  SELECT_IDEAS_BOARD,
  ({ slug }: { slug: string }) =>
    (state: IdeasState): IdeasState => ({ ...state, selectedBoardSlug: slug }),
);
export const unselectBoardHandler = createReducer(
  UNSELECT_IDEAS_BOARD,
  () =>
    (state: IdeasState): IdeasState => ({ ...state, selectedBoardSlug: null }),
);
